import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Signuptogetstarted from "../Signuptogetstarted";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import PhoneInput from "react-phone-input-2";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import VerifyOTP from "../VerifyOTP/VerifyOTP";
import "react-phone-input-2/lib/style.css";
import { handleKeyDown } from "../../../Common/FewCommonMethods";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { detectCountryFromIP } from "../../../../utils/detectCountryFromIP";
import { mobilenumbervalidation } from "../../../Common/commonvalidation";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  country_code: Yup.string().required("Country code is required"),
  mobile_number: mobilenumbervalidation,

});

export default function LoginwithMobile() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [nextPage, setNextPage] = useState(true);
  const [valuess, setValuess] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [selectCountryCode, setSelectCountryCode] = useState("");

  useEffect(() => {
    detectCountryFromIP().then((res) => {
      setSelectCountryCode(res.dial_code || '+91');
    });
  }, []);


  const initialValues = {
    country_code: valuess?.country_code || selectCountryCode || "+966",
    mobile_number: "",
  };

  const handleSubmit = (values) => {
    checkMobile(values)
      .then((res) => {
        if (res.data.status) {
          sendOTP(values)
            .then((res) => {
              if (res.data.status) {
                urtoast(`OTP sent successfully.`, 1);
                setNextPage(false);
                setValuess(values);
              } else {
                urtoast(`${res?.data?.response?.message}`, 2);
              }
            })
            .catch((e) => {
              urtoast(`${e.message} || "Error sending OTP"`, 2);
            });
        } else {
          urtoast(`${res.data.response.message}.`, 2);
        }
      })
      .catch((e) => {
        urtoast(`${e.message}.`, 2);
      })
      .finally(() => { });
  };

  const modifyCountyCodeValue = (
    setFieldValue,
    countryCode,
    mobileWithCounty
  ) => {
    setFieldValue("country_code", `+${countryCode}`);
  };

  return (
    <>
      {nextPage ? (
        <div className="mx-auto register">
          <h1 className="heading">Login account</h1>
          <Signuptogetstarted />

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}  // Add this line
          >
            {({ errors, values, touched, setFieldValue }) => (
              <Form>
                <div className="col-md-8 mx-auto form-sec mobile-otp">
                  <div className="row">
                    <div className="form-group col-md-4 col-5">
                      <label htmlFor="country_code">Country Code <AsteriskLabel /></label>
                      <PhoneInput
                        country={"sa"}
                        value={values.country_code}
                        onChange={(value, country) => {
                          modifyCountyCodeValue(
                            setFieldValue,
                            country.dialCode,
                            value
                          );
                        }}
                        inputProps={{
                          name: "mobile_number",
                          id: "mobile_number",
                          className: "form-control",
                          readOnly: true,
                        }}
                        specialLabel=""
                        // inputclassName="d-none"
                        buttonStyle={{
                          borderRadius: "0",
                          border: "1px solid #ced4da",
                        }}
                        containerStyle={{ marginBottom: "10px" }}
                      />
                      <ErrorMessage
                        name="country_code"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="form-group col-md-8 col-7 pl-0">
                      <label htmlFor="mobile_number">Mobile Number <AsteriskLabel /></label>
                      <Field
                        type="text"
                        name="mobile_number"
                        className={`form-control ${errors.mobile_number && touched.mobile_number
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Enter mobile number"
                        onKeyDown={handleKeyDown}
                      />
                      <ErrorMessage
                        name="mobile_number"
                        component="div"
                        className="error"
                      />
                    </div>
                  </div>
                  <div className="last-form">
                    <button type="submit" className="btn create-account">
                      Continue
                    </button>
                    <a
                      onClick={() => navigate(`/${lan}/loginwithemail`)}
                      className="login-password"
                    >
                      Login with Email
                    </a>
                    <p>
                      Don’t have an account?
                      <a onClick={() => navigate(`/${lan}/signup`)}> Sign up</a>
                    </p>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <VerifyOTP setnextPage={setNextPage} valuess={valuess} />
      )}
    </>
  );
}
